/**
 * Centralized app version configuration.
 * VITE_APP_VERSION is set to the git SHA by CI/CD, or a local fallback from .env.
 * This is the SINGLE source of truth — do not read VITE_APP_VERSION elsewhere.
 */

/** The deployment version (git SHA in CI, semver-like string locally). */
export const APP_DEPLOY_VERSION: string =
  (import.meta.env.VITE_APP_VERSION as string) || 'local-dev';

/** Build environment identifier. */
export const BUILD_ENV: string =
  (import.meta.env.VITE_BUILD_ENV as string) || 'dev';

/** True when running a CI build (version is a 40-char hex SHA). */
export const isCIBuild: boolean = /^[0-9a-f]{40}$/i.test(APP_DEPLOY_VERSION);

/** Short version for display (first 7 chars of SHA, or the full local string). */
export const APP_DEPLOY_VERSION_SHORT: string = isCIBuild
  ? APP_DEPLOY_VERSION.slice(0, 7)
  : APP_DEPLOY_VERSION;
